import { useEffect } from "react";

const Logout = () => {
    useEffect(() => {
        const utype = localStorage.getItem('utype');
        const isSarvenoTokenLogin = localStorage.getItem('sarvenoTokenLogin') === '1';
        
        if (localStorage.getItem('tokenLogin') === '1') {
            localStorage.removeItem('tokenLogin');
            // Clear sarveno token login flag if it exists
            if (isSarvenoTokenLogin) {
                localStorage.removeItem('sarvenoTokenLogin');
            }
            window.location.replace('https://app.sarvcrm.com');
            return;
        }
        
        localStorage.removeItem("token");
        /*
        localStorage.removeItem("registration");
        localStorage.removeItem("notifyby");
        localStorage.removeItem("utype");
        */
        localStorage.removeItem("language");
        localStorage.removeItem("theme");
        
        // Redirect based on utype or sarveno token login flag
        if (utype === 'sarveno' || isSarvenoTokenLogin) {
            window.location.replace('https://app.sarvcrm.com');
        } else {
            window.location.replace('/');
        }
    }, []);
    return null;
};

export default Logout;
